import { useMutation, useQuery } from "@tanstack/react-query";
import { GetAllMarketPlaceUrl,GetMarketPlaceByIdUrl,ActivateAppUrl } from "../utils/constants";
import { useApi } from "./useApi";

export type errorTypeWebsiteBuilder = {
  response: {
    data: { errorMessages: { messageAr: string; messageEn: string }[] };
  };
};

//Api Hooks
const useAppMarket = () => {
  const { apiPrivate } = useApi();

  const GetAllMarketPlaceApi = async (searchKey:any) => {
    const { data } = await apiPrivate.get(`${GetAllMarketPlaceUrl}?searchKey=${searchKey}`);
    return data;
  };

  const GetMarketPlaceByIdApi = async ({id}:any) => {
    const { data } = await apiPrivate.get(`${GetMarketPlaceByIdUrl}?id=${id}`);
    return data;
  };

  const ActivateAppApi = async ({ id, body }: any) => {
    const { data } = await apiPrivate.post(
      `${ActivateAppUrl}?id=${id}`,
      {
        credentials: JSON.stringify(body)
      },
      {
        headers: {
          'Content-Type': 'application/json', 
        },
      }
    );
    return data;
  };

  const GetAllMarketPlaceQuery = (searchKey:any) =>
    useQuery({
      enabled: true,
      queryKey: [GetAllMarketPlaceUrl,searchKey],
      queryFn: ({ queryKey }) => GetAllMarketPlaceApi(searchKey),
    });

const GetMarketPlaceByIdQuery = (data: { id: any }) =>
  useQuery({
    enabled: true,
    queryKey: [GetMarketPlaceByIdUrl, data?.id],
    queryFn: ({ queryKey }) => GetMarketPlaceByIdApi(data),
  });

  //mutation

  const ActivateAppMutate = ({
    onSuccess,
    onError,
  }: {
    onSuccess?: () => void;
    onError?: (error: errorTypeWebsiteBuilder) => void;
  }) =>
    useMutation({
      mutationFn: (body: any) => ActivateAppApi(body),
      onSuccess: (data) => onSuccess && onSuccess(),
      onError: (error: errorTypeWebsiteBuilder) => onError && onError(error),
    });
 
    return {
      GetAllMarketPlaceQuery,GetMarketPlaceByIdQuery,ActivateAppMutate};
  };

export { useAppMarket };
